import styled from 'styled-components';
import { borderRadius, colors, spacing } from 'ui/theme';
import { Add16 } from 'ui/icons/action/Add16';
import { getIconColor, isOptionSelected } from './utils';

const StyledAddIcon = styled(Add16)`
  border-radius: ${borderRadius.xl};
  border: ${spacing.eighth} solid ${colors.green50};

  &[data-selected='false'] {
    border-color: ${colors.textSecondary};
  }
`;

export const AndIcon = ({ color }: { color?: string }) => {
  const isSelected = isOptionSelected(color);
  return <StyledAddIcon data-selected={isSelected} color={getIconColor(colors.green100, color)} />;
};
